const ACTION_PREFIX = 'loading';
export const LoadingActionTypes = {
  PAGE_LOADING: `${ACTION_PREFIX}/PAGE_LOADING`,
  PAGE_LOADING_COMPLETED: `${ACTION_PREFIX}/PAGE_LOADING_COMPLETED`,
};

export function pageLoading(pageName) {
  return {
    type: LoadingActionTypes.PAGE_LOADING,
    payload: {
      pageName,
    },
  };
}

export function pageLoadingFinished() {
  return {
    type: LoadingActionTypes.PAGE_LOADING_COMPLETED,
  };
}

export const LoadingActions = {
  pageLoading,
  pageLoadingFinished,
};
